// Tab "Budget": schatting op basis van de prijs bij de gekozen optie per item.
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { meldFout } from '../../../utils/apiFout';
import { haalBudget, CATEGORIEEN, INKT, LIJN, STIL } from '../breakdownApi';
import { Kaart, Kop, Leeg, Rij, Uitleg } from '../onderdelen';

const euro = (n) => `€ ${Number(n || 0).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function BudgetTab({ productie, items }) {
  const [budget, setBudget] = useState(null);

  useEffect(() => {
    let weg = false;
    haalBudget(productie.id).then((b) => { if (!weg) setBudget(b); }).catch((e) => meldFout(e, 'Budget laden'));
    return () => { weg = true; };
  }, [productie.id, items]);

  if (!budget) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={22} /></Box>;
  if (budget.rows.length === 0) return <Leeg>Nog geen bedragen. Kies bij items een optie met een prijs, dan verschijnt hier de schatting.</Leeg>;

  return (
    <Box>
      <Uitleg>Schatting op basis van de prijs bij de gekozen optie (het eerste bedrag in de prijs telt). Controleer het totaal altijd zelf.</Uitleg>
      {CATEGORIEEN.filter((c) => budget.rows.some((r) => r.category === c.key)).map((c) => (
        <Box key={c.key} sx={{ mb: 2 }}>
          <Kop rechts={<Typography sx={{ fontSize: 13.5, fontWeight: 700 }}>{euro(budget.by_category[c.key])}</Typography>}>{c.icoon} {c.label}</Kop>
          <Kaart>
            {budget.rows.filter((r) => r.category === c.key).map((r) => (
              <Rij key={`${r.name}-${r.option_name}`}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography noWrap sx={{ fontSize: 13.5, color: INKT }}>{r.name}</Typography>
                  <Typography noWrap sx={{ fontSize: 12.5, color: STIL }}>{r.option_name}</Typography>
                </Box>
                <Typography sx={{ fontSize: 13, color: r.amount == null ? '#b45309' : INKT, whiteSpace: 'nowrap' }}>
                  {r.price_text || 'geen prijs'}{r.amount == null && r.price_text ? ' (telt niet mee)' : ''}
                </Typography>
              </Rij>
            ))}
          </Kaart>
        </Box>
      ))}
      <Box sx={{ display: 'flex', alignItems: 'baseline', borderTop: `2px solid ${LIJN}`, pt: 1.5, mt: 1 }}>
        <Typography sx={{ flex: 1, fontSize: 15, fontWeight: 700 }}>Totaal (schatting)</Typography>
        <Typography sx={{ fontSize: 20, fontWeight: 800 }}>{euro(budget.grand_total)}</Typography>
      </Box>
      {budget.missing_price_count > 0 && (
        <Typography sx={{ mt: 0.5, fontSize: 12.5, color: '#b45309' }}>{budget.missing_price_count} gekozen optie(s) zonder herkenbaar bedrag tellen niet mee.</Typography>
      )}
    </Box>
  );
}
